module.exports = {"id":"188992","name":"Marcelo Estigarribia","rating":"72","photo":"./data/images/photos/4/188992.png","club":{"name":"Santa Fe","logo":"./data/images/clubs/SantaFe.png"},"positions":["MD","MG","DG"],"photoFolderIndex":4}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/MarceloEstigarribia0.json
// module id = 2720
// module chunks = 0